import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import EngineeringIcon from '@mui/icons-material/Engineering';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { getsales} from '../redux/sales';
import { getmechanization} from '../redux/mechanization';

import { useSelector, useDispatch } from 'react-redux';
import Progress from '../components/Loader';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 550,
  height: '100%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function BasicModal() {
  const dt = new Date();
  const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
  const day = dt.getUTCDate();
  const month = String(dt.getMonth() + 1).padStart(2, '0');
  const year = dt.getFullYear();
  const date = year + "-" + month + "-" + day;
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const [open, setOpen] = React.useState(false);
  const [loading, setloading] = React.useState(false);
  const [gender, setgender] = React.useState("none");
  const [customer, setcustomer] = React.useState("none");
  const [customertype, setcustomertype] = React.useState("none");
  const [productservice, setproductservice] = React.useState("none");
  const [position, setposition] = React.useState("none");
  const [cultivatingmethod, setcultivatingmethod] = React.useState("none");
  const [croptype, setcroptype] = React.useState("none");
  const [seed, setseed] = React.useState("none");
  const [fertilizer, setfertilizer] = React.useState("none");
  const [water, setwater] = React.useState("none");
  const [unit, setunit] = React.useState("none");
  const [haullier, sethaullier] = React.useState("none");
  const [chosenhaullier, setchosenhaullier] = React.useState([]);
  const [method, setmethod] = React.useState("none");
  const [drivername, setdrivername] = React.useState("none");
  const [drivercontact, setdrivercontact] = React.useState("none");
  const [vehicleregistration, setvehicleregistration] = React.useState("none");
  const [personName, setPersonName] = React.useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();

  const admin = useSelector((state) => state.admin);
  const farmer = useSelector((state) => state.farmer);
  const product = useSelector((state) => state.product);
  const staff = useSelector((state) => state.staff);
  const sales = useSelector((state) => state.sales);
  const agent = useSelector((state) => state.hauler);
  const agents = useSelector((state) => state.agent);
  const warehouse = useSelector((state) => state.warehouse);
  const service = useSelector((state) => state.service);
  const haullier_ = useSelector((state) => state.hauler);
  const center = useSelector((state) => state.center);
  const commodity = useSelector((state) => state.commodity);
  const customer_ = useSelector((state) => state.customer);
  const idmain = "SA" + year + "0Q" + month + "00" + (sales.length % parseInt(day));

  const Food = [
    { value: "Cereals" },
    { value: "Industrial crops" },
    { value: "Legumes" },
    { value: "Fruits" },
    { value: "Vegetables" },
    { value: "Starchy" },
    { value: "tuber" },
    { value: "root crops" }
  ];

  const names = [
    "Maize",
    "Soya Beans",
    "Onion",
    "Pepper",
    "Tomatoes"
  ];

  const handleChange = (event) => {
    const { target: { value } } = event;
    setPersonName(typeof value === 'string' ? value.split(',') : value);
  };

  const clearForm = () => {
    setcustomer("none");
    setPersonName([]);
    setmethod("none");
    document.getElementById("community").value = "";
    document.getElementById("district").value = "";
    document.getElementById("tractor").value = "";
    document.getElementById("operator").value = "";
    document.getElementById("others").value = "";
    personName.forEach((list, i) => {
      document.getElementById(list + i).value = "";
      document.getElementById(list + "rate" + i).value = "";
    });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  const addfarmer = () => {
    setloading(true);
    const list = [];
    for (const i in personName) {
      const product = personName[i];
      const qty = document.getElementById(personName[i] + i).value;
      const unitp = document.getElementById(personName[i] + "rate" + i).value;
      const contact = chosenhaullier.vehicleslist ? chosenhaullier.vehicleslist.filter(bug => bug.drinername === drivername)[0]?.contact : "";
      list.push({ product, qty, unitp });
    }

    const doer = async () => {
      try {
        const res = await axios.post("https://embert.sisrevolution.com/api/mechanization/addmechanization/", {
          operator: document.getElementById("operator").value,
          tractornumber: document.getElementById("tractor").value,
          district: document.getElementById("district").value,
          community: document.getElementById("community").value,
          vehicle: vehicleregistration,
          purchase: list,
          invoice: idmain,
          customer,
          paymentmethod: method,
          others: document.getElementById("others").value,
        });
        console.log("res.data");
        console.log(res.data);
        if (res.status === 200) {
          setloading(false);
          dispatch(getmechanization({ data: res.data } ));
          setSnackbarMessage('Mechanization added successfully!');
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          clearForm();
          handleClose();
        } else {
          setloading(false);
          setSnackbarMessage('Failed to add mechanization.');
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      } catch (err) {
        setloading(false);
        setSnackbarMessage('An error occurred while adding mechanization.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    };

    doer();
  };

  const haullierchooser = (data) => {
    sethaullier(data);
    const chosendata = haullier_.filter(bug => bug.haullier === data);
    setchosenhaullier(chosendata);
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<EngineeringIcon />} onClick={handleOpen}>
        Add Mechanization
      </Button>
      <Dialog fullWidth minWidth="sm" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          New Mechanization Module
          <IconButton onClick={handleClose} style={{ float: "right" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="outlined-select-currency-native"
              select
              label="Choose Farmer"
              value={customer}
              onChange={(e) => setcustomer(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option key="none" value="none">Choose Farmer</option>
              {farmer.map((list) => (
                <option key={list._id} value={list._id}>{list.farmername}</option>
              ))}
            </TextField>
            <FormControl sx={{ m: 1, width: 225 }}>
              <InputLabel id="demo-multiple-checkbox-label">Choose Service(s)</InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={personName}
                onChange={handleChange}
                input={<OutlinedInput label="Choose Service(s)" />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
              >
                {service.map((name) => (
                  <MenuItem key={name.servicename} value={name.servicename}>
                    <Checkbox checked={personName.includes(name.servicename)} />
                    <ListItemText primary={name.servicename} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {personName.map((list, i) => (
              <div key={i} style={{ border: "solid", borderWidth: "1px", borderRadius: "5px", borderColor: "gray", padding: "10px" }}>
                <TextField
                  id={list + i}
                  label={list + " Acreage"}
                  type="text"
                  autoComplete="current-text"
                />
                <TextField
                  id={list + "rate" + i}
                  label={list + " Rate"}
                  type="text"
                  defaultValue={service.filter(bud => bud.servicename === list)[0]?.rate}
                  autoComplete="current-text"
                />
              </div>
            ))}
            <TextField
              id="community"
              label="Community"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="district"
              label="District"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="tractor"
              label="Tractor Number"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="operator"
              label="Operator's Name"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="outlined-select-currency-native"
              select
              label="Payment Method"
              value={method}
              onChange={(e) => setmethod(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option key="none" value="none">Choose</option>
              <option key="Cash" value="Cash">Cash</option>
              <option key="Cheque" value="Cheque">Cheque</option>
              <option key="Credit" value="Credit">Credit</option>
            </TextField>
            <TextField
              id="others"
              label="Other Descriptions"
              multiline
              rows={4}
            />
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <div style={{ marginTop: 2, textAlign: "center", width: "100%" }}>
            {loading ? (
              <Button variant="outlined" startIcon={<Progress />} disabled>
                Loading...
              </Button>
            ) : (
              <Button variant="outlined" startIcon={<EngineeringIcon />} size="large" onClick={addfarmer}>
                Submit New Sales
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}